import NavbarSearch from './Navbar-Search';
import PresumedCredit from './results/presumedCredit';

export default function CreditPresumidPage() {
  return (
    <>
      <NavbarSearch />
      <div className="flex-1 bg-gray-50 flex flex-col items-center py-10 px-4">
        <header className="w-full max-w-7xl">
          <h1 className="text-[#3d2d6b] text-2xl font-bold">Crédito presumido</h1>
        </header>
        <div className="w-full max-w-7xl mt-5 text-center">
          <PresumedCredit />
        </div>
      </div>
    </>
  );
}